import pluralize from 'pluralize';
import React, { useState } from 'react';
import styled from 'styled-components';
import { Checkbox } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import ProjectDetails from './ProjectDetails';

const CheckboxArea = styled.div`
  padding-top: 0.75rem;
`;

export default function BulkArchive({ ids, projects = [], onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();
  const [shouldUpdateStatus, setShouldUpdateStatus] = useState(false);

  const archiveableProjects = projects.filter((project) => project.recordStatusId !== 'archived');
  const canSetCompletedStatus =
    archiveableProjects.some((project) => project.statusId !== 'completed') &&
    archiveableProjects.every((project) => project.statusId === 'completed' || project.permissions.edit);

  return (
    <BulkActionModal
      title="Bulk Archive"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projects()
          .bulkSetRecordStatus(ids, {
            recordStatusId: 'archived',
            statusId: shouldUpdateStatus ? 'completed' : undefined,
          })
          .then((r) => r.data)
      }
      renderRow={ProjectDetails}>
      {`Are you sure you want to archive ${ids.length} ${pluralize('project', ids.length)}? This will stop any running timers for these projects.`}
      {canSetCompletedStatus && (
        <CheckboxArea>
          <Checkbox
            label={`Set ${ids.length === 1 ? "this project's" : "these projects'"} status to Completed.`}
            checked={shouldUpdateStatus}
            onChange={(e) => {
              setShouldUpdateStatus(e.target.checked);
            }}
          />
        </CheckboxArea>
      )}
    </BulkActionModal>
  );
}
